var _rect, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCycleIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.275,
    y: 0.275,
    width: 21.45,
    height: 21.45,
    rx: 10.725,
    stroke: "#43419E",
    strokeWidth: 0.55
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#bpmg3faz7a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.621 9.948a3.09 3.09 0 0 0-.51.042l-.575-1.774v-.001l-.445-1.407h.9c.47 0 .85.381.85.85a.45.45 0 0 0 .902 0c0-.966-.786-1.752-1.752-1.752h-1.514a.45.45 0 0 0-.43.587l.479 1.517-4.51.94-.465-.796h.37a.45.45 0 0 0 0-.902h-2.15a.45.45 0 0 0 0 .901h.737l.75 1.287-.546.81a3.084 3.084 0 0 0-4.41 2.778 3.084 3.084 0 0 0 3.08 3.08A3.085 3.085 0 0 0 9.43 13.48h1.124v.476l-.383.094a.45.45 0 1 0 .216.876l.695-.172a.43.43 0 0 0 .063-.015l.722-.178a.45.45 0 1 0-.216-.876l-.196.049v-.569l2.51-3.786.289.89a3.084 3.084 0 0 0-1.713 2.76 3.084 3.084 0 0 0 3.08 3.08 3.084 3.084 0 0 0 3.08-3.08 3.084 3.084 0 0 0-3.08-3.08zm-6.846.339 1.42 2.29H9.43a3.077 3.077 0 0 0-.971-1.822l.316-.468zm-.828 1.227c.28.29.481.655.567 1.064H7.23l.717-1.064zm-1.565 3.693a2.182 2.182 0 0 1-2.179-2.179A2.182 2.182 0 0 1 7.2 11.01L6.01 12.776a.45.45 0 0 0 .373.703h2.132a2.183 2.183 0 0 1-2.132 1.728zm4.635-3.014L9.513 9.768l3.611-.752-2.107 3.178zm4.604 3.014a2.182 2.182 0 0 1-2.179-2.179c0-.806.44-1.511 1.094-1.888l.657 2.027a.45.45 0 1 0 .857-.278l-.657-2.028a2.182 2.182 0 0 1 2.408 2.167c0 1.202-.978 2.18-2.18 2.18z",
    fill: "#43419E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "bpmg3faz7a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(3.3 2.203)",
    d: "M0 0h15.4v15.4H0z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCycleIcon);
export default __webpack_public_path__ + "static/media/cycle-icon.9eda9758.svg";
export { ForwardRef as ReactComponent };